module.exports = __webpack_public_path__ + "static/media/merin.113be351.jpg";